<template>
  <div>
    <router-link :to="{ name: 'Agent' }" class="btn-primary-sm text-xs inline-block">Open the agent</router-link>
  </div>
</template>

<script>
export default {
  name: 'OverviewETLAgent',
  methods: {
    openFile(s3Key) {
      this.$router.push({ name: 'Agent', query: s3Key ? { file: s3Key } : {} });
    },
  },
};
</script>
